<template>
  <div class="apply-for-health-code">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="学生姓名" prop="studentName" :error="dataError">
        <el-input v-model="form.studentName"
                  placeholder="请输入学生姓名"
                  maxlength="16"
                  show-word-limit
                  @input="getStatusWithName"></el-input>
      </el-form-item>
      <el-form-item label="学校名称" prop="schoolName" :class="[hasSchoolId?'is-disabled-school':'']">
        <el-select v-model="form.schoolName" placeholder="请选择或输入学校名称" class="select-box"
                   @change="changeSchool" :disabled="hasSchoolId">
          <el-option v-for="(item,index) in schoolList" :value="item.schoolId" :label="item.schoolName"
                     :key="item.schoolId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班级名称" prop="className">
        <el-select v-model="form.className" placeholder="请选择班级名称" class="select-box" @change="changeClass">
          <el-option v-for="(item,index) in currentClassList" :value="item.classId" :label="item.className"
                     :key="item.classId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份证号" prop="cardId">
        <el-input v-model="form.cardId" placeholder="请输入学生身份证号码"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn" :class="[canEdit?'allow':'no-allow']" @click="canEdit?handleSubmit():''">申请开通</div>
    <el-dialog :visible.sync="showDialog"
               center width="80%"
               custom-class="dialog-box"
               :show-close="false">
      <div class="dialog-wrapper">
        <img src="@/assets/applyForHealthCode/success.png" class="success">
        <div class="text1">恭喜您开通成功！</div>
        <div class="text2">请重启学生证后验证</div>
        <div class="btn" @click="iKnow">我知道了</div>
      </div>
    </el-dialog>
    <div class="notice">
      <div class="notice-title">注意事项</div>
      <div v-for="(item,index) in notice.first" :key="index">
        {{ index + 1 }}.{{ item }}
      </div>
    </div>
    <div class="notice">
      <div class="notice-title">知情通知</div>
      <div>{{ notice.second }}</div>
    </div>
  </div>
</template>

<script>
import {checkPsidno} from "@/utils/vaildate";
import {listSchoolWhiteByStudentName, openHealthCode} from "@/api/studentCard";
import {getUrlParam} from "@/utils/util";

export default {
  name: "applyForHealthCode",
  data() {
    var checkCardId = (rule, value, callback) => {
      let result = checkPsidno(value)[0];
      if (!result) {
        callback(new Error("请输入正确的18位身份证号"))
      } else {
        callback();
      }
    }
    return {
      hasSchoolId: true,
      showDialog: false,
      notice: {
        first: [
          "开通学生证健康码后，您孩子的健康码信息将在学生证上显示;",
          "如您有多个孩子申领健康码，请依次为每个孩子申领;",
          "如您多次开通失败，请检查信息是否填写准确;",
          "已开通的孩子，请勿重复申请开通;",
          "更多疑问请咨询人工客服（0512）6666 6628。"
        ],
        second: "您填写的身份证信息仅在开通学生证健康码时进行校 验使用，我们不会收集相关信息。您开通学生证健康 码后，学生证健康码信息内容由对应地区健康码平台 提供，我们仅做数据展示。"
      },
      form: {
        studentName: "",
        schoolName: "",
        className: "",
        cardId: ""
      },
      rules: {
        cardId: [
          {validator: checkCardId, trigger: 'blur'}
        ],
      },
      dataError: "",
      schoolList: [],
      currentClassList: [],
      studentId: "",
      schoolId: "",
      schoolName: ""
    }
  },
  computed: {
    canEdit() {
      // 四个输入框都有值的时候可以点击按钮
      return this.form.studentName && this.form.schoolName && this.form.className && this.form.cardId;
    }
  },
  mounted() {
    //TODO schoolId如果传过来，固定学校，前端过滤信息资源,当前仅供测试，苏州外国语学院
    let schoolId = getUrlParam("schoolId")
    let schoolName = decodeURIComponent(getUrlParam("schoolName"))
    // let schoolId = "b4adcdcb-8c75-4c46-a74f-8deff338d324"
    // let schoolName = "苏州外国语学校";
    if (schoolId && schoolName) {
      this.hasSchoolId = true;
      this.schoolId = schoolId;
      this.schoolName = schoolName;
      this.schoolList = [{schoolId: this.schoolId, schoolName: this.schoolName}]
      this.form.schoolName = this.schoolId;
    } else {
      this.hasSchoolId = false;
    }
  },
  methods: {
    getStatusWithName() {
      let that = this;
      // 修改学生姓名后，清空数据
      that.schoolList = [];
      that.currentClassList = [];
      if (!that.hasSchoolId) {
        //如果有学校id过来，关于学校信息是不清空
        that.form.schoolName = "";
      }
      that.form.className = "";
      that.form.cardId = "";
      if (!that.form.studentName) {
        that.dataError = "";
        return;
      }
      listSchoolWhiteByStudentName({childUserName: that.form.studentName}).then(res => {
        if (res.status === 200) {
          that.schoolList = res.content;
          let num = this.schoolList.length;
          if (!that.hasSchoolId) {//如果有默认的学校了，不再进行更改
            if (num === 1) {
              // 学生在白名单内，只有单一学校，则默认选中学校
              that.form.schoolName = that.schoolList[0].schoolId;
              //获取单一学校里面的班级数据
              that.setClassList(that.schoolList[0].classList);
            } else if (num > 1) {
              // 学生在白名单内，同时有多个学校，则默认不选中学校；
              if (that.schoolId) {
                that.form.schoolName = that.schoolId;
                that.changeSchool(that.schoolId)
              }
            }
          } else {
            let result = that.schoolList.find(p => p.schoolId === that.schoolId);
            if (result) {
              that.setClassList(result.classList);
            } else {
              that.dataError = "学生不存在或未绑定学生"
              return;
            }
          }
        }
        that.dataError = res.status === 200 ? "" : res.content;
      })
    },
    changeSchool(e) {
      let result = this.schoolList.filter(p => {
        return p.schoolId === e;
      })
      this.setClassList(result[0].classList);
    },
    changeClass(e) {
      let result = this.currentClassList.filter(p => {
        return p.classId === e;
      })
      this.studentId = result[0].studentId;
    },
    setClassList(classList) {
      //将默认选中学校的班级进行赋值
      this.currentClassList = classList;
      let classListNum = classList.length;
      if (classListNum === 1) {
        // 如果班级只有一个，则默认选中这个班级
        this.form.className = classList[0].classId;
        this.studentId = classList[0].studentId;
      } else if (classListNum > 1) {
        // 如果班级存在多个，则默认不选中任何班级
      }
    },
    iKnow() {
      //  点击我知道了退出页面
      this.showDialog = false;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            childUserName: this.form.studentName,
            childUserId: this.studentId,
            classId: this.form.className,
            schoolId: this.form.schoolName,
            idCard: this.form.cardId,
          }
          openHealthCode(params).then(res => {
            if (res.status === 200) {
              this.showDialog = true;
            } else {
              console.log(res.content)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    }
  }
}
</script>
<style lang="scss">
.apply-for-health-code .el-form-item--medium .el-form-item__content,
.apply-for-health-code .el-form-item--medium .el-form-item__label {
  line-height: 50px;
}

.apply-for-health-code .el-input__inner {
  border: none;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
}

.apply-for-health-code .el-form-item__label {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
}

.apply-for-health-code .el-input.is-disabled .el-input__inner {
  background-color: #EAEAEA;
  color: #222222;
}

.dialog-box.el-dialog {
  border-radius: 15px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    //padding: 0;
  }
}
</style>
<style lang="scss" scoped>

.apply-for-health-code {
  width: 100%;
  height: 100%;
  background-color: #F5F5F5;
  padding: 10px;
  overflow-y: auto;

  .el-form-item {
    background-color: #FFFFFF;
    padding: 0 10px 0 0;
    border-radius: 10px;
  }

  .is-disabled-school {
    background-color: #EAEAEA;
  }

  .select-box {
    width: 100%;
  }

  .btn {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #2AD0B5;
    border-radius: 10px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }

  .allow {
    background: #2AD0B5;
  }

  .no-allow {
    background: #D5D5D5;
    cursor: not-allowed;
  }

  .dialog-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .success {
      width: 80px;
      height: 60px;
      margin-bottom: 20px;
    }

    .text1 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: #222222;
      margin-bottom: 25px;
      letter-spacing: 1.5px;
    }

    .text2 {
      letter-spacing: 1.5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      margin-bottom: 30px;
    }

    .btn {
      height: 46px;
      background: #2AD0B5;
      border-radius: 23px;
    }
  }

  .notice {
    margin-top: 30px;
    padding: 0 8px;

    .notice-title {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 700;
      color: #222222;
      margin-bottom: 5px;
    }

    div {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      text-align: justify;
      //text-justify: inter-ideograph;
      //text-justify: inter-cluster;
      //text-justify: inter-word;
      letter-spacing: 1.5px;
    }
  }
}
</style>